var map = {
	"./1.png": 31,
	"./11.png": 37,
	"./2.png": 32,
	"./3.png": 33,
	"./33.png": 35,
	"./6.png": 34,
	"./Bakery  Pastry - Breakfast 2 1.png": 30,
	"./Mask Group 4.png": 42,
	"./Mask Group-1.png": 39,
	"./Mask Group-2.png": 40,
	"./Mask Group-3.png": 41,
	"./Mask Group.png": 36,
	"./Screenshot 2020-07-29 13.44.57.png": 38,
	"./abstract.png": 27,
	"./business/1-1.png": 72,
	"./business/1-2.png": 73,
	"./business/1-3.png": 74,
	"./business/1-4.png": 75,
	"./business/1-5.png": 76,
	"./business/2-1.png": 77,
	"./business/2-2.png": 78,
	"./business/2-3.png": 79,
	"./business/2-4.png": 80,
	"./business/2-5.png": 81,
	"./business/3-1.png": 82,
	"./business/3-2.png": 83,
	"./business/3-3.png": 84,
	"./business/3-4.png": 85,
	"./business/3-5.png": 86,
	"./business/4-1.png": 87,
	"./business/4-2.png": 88,
	"./business/4-3.png": 89,
	"./business/4-4.png": 90,
	"./business/4-5.png": 91,
	"./canvas.png": 28,
	"./children/1-1.png": 92,
	"./children/1-2.png": 93,
	"./children/1-3.png": 94,
	"./children/1-4.png": 95,
	"./children/1-5.png": 96,
	"./children/2-1.png": 97,
	"./children/2-2.png": 98,
	"./children/2-3.png": 99,
	"./children/2-4.png": 100,
	"./children/2-5.png": 101,
	"./children/3-1.png": 102,
	"./children/3-2.png": 103,
	"./children/3-3.png": 104,
	"./children/3-4.png": 105,
	"./children/3-5.png": 106,
	"./children/4-1.png": 107,
	"./children/4-2.png": 108,
	"./children/4-3.png": 109,
	"./children/4-4.png": 110,
	"./children/4-5.png": 111,
	"./fashion/1-1.png": 112,
	"./fashion/1-2.png": 113,
	"./fashion/1-3.png": 114,
	"./fashion/1-4.png": 115,
	"./fashion/1-5.png": 116,
	"./fashion/2-1.png": 117,
	"./fashion/2-2.png": 118,
	"./fashion/2-3.png": 119,
	"./fashion/2-4.png": 120,
	"./fashion/2-5.png": 121,
	"./fashion/3-1.png": 122,
	"./fashion/3-2.png": 123,
	"./fashion/3-3.png": 124,
	"./fashion/3-4.png": 125,
	"./fashion/3-5.png": 126,
	"./fashion/4-1.png": 127,
	"./fashion/4-2.png": 128,
	"./fashion/4-3.png": 129,
	"./fashion/4-4.png": 130,
	"./fashion/4-5.png": 131,
	"./food/1-1.png": 132,
	"./food/1-2.png": 133,
	"./food/1-3.png": 134,
	"./food/1-4.png": 135,
	"./food/1-5.png": 136,
	"./food/2-1.png": 137,
	"./food/2-2.png": 138,
	"./food/2-3.png": 139,
	"./food/2-4.png": 140,
	"./food/2-5.png": 141,
	"./food/3-1.png": 142,
	"./food/3-2.png": 143,
	"./food/3-3.png": 144,
	"./food/3-4.png": 145,
	"./food/3-5.png": 146,
	"./food/4-1.png": 147,
	"./food/4-2.png": 148,
	"./food/4-3.png": 149,
	"./food/4-4.png": 150,
	"./food/4-5.png": 151,
	"./sport_4.png": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;